import styles from "./CircuitBreakerIndicator.module.css";

export type CircuitBreakerState = "ARMED" | "SAFE" | "TRIPPED";

export interface CircuitBreakerIndicatorProps {
  state: CircuitBreakerState;
}

const STATE_CONFIG: Record<CircuitBreakerState, { label: string; className: string }> = {
  ARMED: { label: "Armed", className: "armed" },
  SAFE: { label: "Safe", className: "safe" },
  TRIPPED: { label: "Tripped", className: "tripped" },
};

export function CircuitBreakerIndicator({ state }: CircuitBreakerIndicatorProps) {
  const config = STATE_CONFIG[state];

  return (
    <div
      className={styles.container}
      data-testid="circuit-breaker-indicator"
      aria-label={`Circuit breaker: ${config.label}`}
      title={`Circuit breaker: ${config.label}`}
    >
      <span className={`${styles.dot} ${styles[config.className]}`} />
      <span className={styles.label}>{config.label}</span>
    </div>
  );
}
